// ----------------------------------------------------------------------
// wrapper for the quagga2 library
// --------------------------------------------------------------------------
import React from 'react';
import PropTypes from 'prop-types';
import Quagga from '@ericblade/quagga2';
import './quagga.css';
// --------------------------------------------------------------------------

// can probably remove these calculations, since use 100% of feed now
const scanWidth = 1;
const scanHeight = 1;

const scanLeft = 0.5-scanWidth/2;
const scanRight = scanLeft+scanWidth;
const scanTop = 0.5-scanHeight/2;
const scanBottom = scanTop+scanHeight;

function toPercentage(fraction) { return `${Math.round(fraction*100)}%`; }

// --------------------------------------------------------------------------
class Scanner extends React.Component {
    
    // ----------------------------------------------------------------------

    componentDidMount() {

        let self = this;

        let cameraId = this.props.useCameraId;

        console.log(`Using camera id: ${cameraId == null ? 'not specified' : cameraId}`);

        let streamConstraints = cameraId == null ? { 
                facingMode: { ideal: 'environment' },
                focusMode: { ideal: "continuous" }
            } : {
                deviceId : cameraId,
                sharpness : 1
            };
        
        Quagga.init( {
            inputStream: {
                type            : 'LiveStream',
                //target          : videoTarget,
                constraints     : streamConstraints,
                area: {                                     // defines rectangle of the detection/localization area
                    top     : toPercentage(scanTop),        // top offset
                    right   : toPercentage(1-scanRight),    // right offset
                    left    : toPercentage(scanLeft),       // left offset
                    bottom  : toPercentage(1-scanBottom)    // bottom offset
                  },
                singleChannel   : false
            },
            debug: false,
            locator: {
                patchSize: 'large', // x-small, small, medium, large, x-large
                halfSample: true,
            },
            numOfWorkers: 4,
            decoder: {
                readers: [ 'ean_reader' ],        
            },
            locate: true,
        }, (err) => {
            if (err) {
                this._onError(err);
                return console.log('Error starting Quagga:', err);
            }
            Quagga.start();
        });

        Quagga.onDetected(this._onDetected.bind(this));
        
        Quagga.onProcessed(function(result) {

        });
            
    }

    // ----------------------------------------------------------------------

    _onDetected(result) {
        this.props.onDetected(result.codeResult.code);
    }

        // ----------------------------------------------------------------------

    _onError(err) {
        this.props.onError(err);
    }

    // ----------------------------------------------------------------------

    componentWillUnmount() {
        Quagga.offDetected(this._onDetected); // why?!
        Quagga.stop();
    }

    // ----------------------------------------------------------------------

    componentDidUpdate(prevProps, prevState) {

        if(prevProps.useCameraId!=this.props.useCameraId) {
            console.log('Changing device');
            try {
                Quagga.stop();
            } catch(e) {}
            this.componentDidMount();
        }

    }

    // ----------------------------------------------------------------------

    render() {

        return (
            <div className="bsScannerOverlay">
                <div id="interactive" className="viewport" />
            </div>
        )
    }
    // ----------------------------------------------------------------------

}

// --------------------------------------------------------------------------

Scanner.propTypes = {
    onDetected: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired
};

// --------------------------------------------------------------------------
export default Scanner;
// --------------------------------------------------------------------------